module.exports = __webpack_public_path__ + "static/1346181098.dd13c2c9.jpg";